<script>
    import Config from "@/services/Config";
    import IConstants from "@/common/constants/IConstants.js";
    import ServiceUtils from "@/common/utils/ServiceUtils.js";
    import {createNamespacedHelpers} from "vuex";

    const {mapState: mapNewsState} = createNamespacedHelpers("news");

    export default {
        name: 'InAppBrowserMixins',
        mixins: [],
        data() {
            return {
                deepLinkCloseFXIOS: Config.getDeepLinkCloseFXIOS(),
                deepLinkCloseFXAndroid: Config.getDeepLinkCloseFXAndroid(),
            }
        },
        mounted() {
        },
        computed: {
            ...mapNewsState({
                needRegisterPasskey: state => state.needRegisterPasskey,
            }),
        },
        methods: {
            inAppBrowserCloseable() {
                this.$service.getService("news").getAgreeNews().then((res) => {
                    if (!this.isMyPageCompleted(res)) return;
                    this.closing()
                });
            },
            store3rdCustomParams() {
                let params = new URLSearchParams(window.location.search);
                if (params.has(IConstants.CUSTOM_PARAM.APP_SOURCE_TYPE)) localStorage.setItem(IConstants.CUSTOM_PARAM.APP_SOURCE_TYPE, params.get(IConstants.CUSTOM_PARAM.APP_SOURCE_TYPE));
                if (params.has(IConstants.CUSTOM_PARAM.X_SOURCE_ID)) localStorage.setItem(IConstants.CUSTOM_PARAM.X_SOURCE_ID, params.get(IConstants.CUSTOM_PARAM.X_SOURCE_ID))
            },
            closing() {
                const xSourceId = localStorage.getItem(IConstants.CUSTOM_PARAM.X_SOURCE_ID);
                const appSourceType = localStorage.getItem(IConstants.CUSTOM_PARAM.APP_SOURCE_TYPE);
                if (!ServiceUtils.hasValue(appSourceType)) return;

                let closeLink;
                if (this.isFxApp(appSourceType)) {
                    if (this.isFxIosApp(appSourceType)) closeLink = this.deepLinkCloseFXIOS;
                    else if (this.isFxAndroidApp(appSourceType)) closeLink = this.deepLinkCloseFXAndroid
                }

                if (closeLink) {
                    localStorage.removeItem(IConstants.CUSTOM_PARAM.APP_SOURCE_TYPE);
                    localStorage.removeItem(IConstants.CUSTOM_PARAM.X_SOURCE_ID);
                    let customCloseLink = this.buildUrlWithCustomParam(closeLink, IConstants.CUSTOM_PARAM.X_SOURCE_ID, xSourceId);
                    window.location.href = customCloseLink
                }
            },
            isFxApp(appSourceType) {
                return appSourceType.includes(IConstants.APP_SOURCE_TYPE.NTD_FX)
            },
            isFxIosApp(appSourceType) {
                return appSourceType.includes(IConstants.APP_SOURCE_TYPE.NTD_FX_IOS)
            },
            isFxAndroidApp(appSourceType) {
                return appSourceType.includes(IConstants.APP_SOURCE_TYPE.NTD_FX_ANDROID)
            },
            isMyPageCompleted(res) {
                let hasReAgreementNews = res.listAmsCustomerNewsView && res.listAmsCustomerNewsView.length > 0;
                let hasAgreementNews = res.listAgreeNewsInfo && res.listAgreeNewsInfo.length > 0;
                let hasForceNews = res.listForceNewsInfo && res.listForceNewsInfo.length > 0;
                return !hasReAgreementNews && !hasAgreementNews && !hasForceNews && !this.needRegisterPasskey
            },
            buildUrlWithCustomParam(originUrl, key, value) {
                if (!ServiceUtils.hasValue(key) || !ServiceUtils.hasValue(value)) return originUrl;

                const [baseUrl, searchString] = originUrl.split('?');
                const params = new URLSearchParams(searchString || '');
                params.set(key, value);

                return `${baseUrl}?${params.toString()}`;
            }
        },
    };
</script>
